import React from 'react'
import { useDispatch } from 'react-redux'
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import { reserveManualModalName } from '../../../constants'
import { translateBase } from '../../../helpers'
import { reserveManual } from 'src/store/loan'

const reserveManualFetcher = 'reserve-manual-fetcher'

const ReserveManualModal = ({ onRefresh }) => {
  const dispatch = useDispatch()

  function handleConfirm({ ID, hash, manRateID }) {
    // dispatch(
    //   fetchSFM({
    //     instanceName: reserveManualFetcher,
    //     callApi: Loan.reserveManual,
    //     callApiArgs: [ID, hash, manRateID],
    //     resolve: onRefresh,
    //   }),
    // )

    //UPDATED API REQUEST loan_oper_api page:reservemanual
    dispatch(
      reserveManual({
        LoanID: ID,
        HashSum_LoanID_: hash,
        ID: manRateID,
      }),
    ).then((response) => {
      if (!reserveManual.fulfilled.match(response)) {
        dispatch(LKModalActions.openInfo(translateBase(response.payload)))
        return
      }
      onRefresh()
    })
  }

  return <LKModal.Confirmation name={reserveManualModalName} onConfirm={handleConfirm} />
}

export const openReserveManualModal = (ID, hash, manRateID) =>
  LKModalActions.openConfirmation(reserveManualModalName, {
    message: translateBase('CONFIRM_MANUAL_RESERVE_START'),
    ID,
    hash,
    manRateID,
  })

export default ReserveManualModal
